<div class="upload-dialog-content-wrapper">
  <input
    type="file"
    #file
    style="display: none"
    (change)="onFilesAdded()"
    multiple
    accept="{{ this.acceptFiles }}"
  />
  <mat-toolbar
    matDialogTitle
    class="mat-accent m-0 mat-dialog-title mat-toolbar mat-toolbar-single-row title-bar"
  >
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title"
        >Upload Files
        <span *ngIf="fileCount > 0" class="h3 secondary"
          >({{ fileCount }})</span
        >
      </span>
      <button
        mat-icon-button
        class="mat-icon-button white-fg"
        mat-dialog-close
        aria-label="Close dialog"
        id="btnClose"
        *ngIf="showCancelButton"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <div mat-dialog-content class="p-24 m-0" style="height: 450px !important">
    <!-- This is the content of the dialog, containing a list of the files to upload -->
    <div
      *ngIf="fileCount < 1"
      fxFlex="grow"
      fxFlexFill
      fxLayoutAlign="center center"
      fxLayout="column"
    >
      <mat-icon class="s-120 mb-12 select-task-icon">cloud_upload</mat-icon>
      <span class="hint-text mat-h3 select-task-text" style="text-align: center"
        >Click the 'Add Files' button to select files to upload</span
      >
    </div>
    <div *ngIf="fileCount > 0" class="w-100-p" style="height: 400px">
      <div *ngFor="let file of files" class="w-100-p">
        <div
          fxFlex="1 0 auto"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          class="clickable row upload-row"
        >
          <div fxFlex fxLayout="column" fxLayoutAlign="start start">
            <div class="h3">
              {{ file.name | slice : 0 : 40
              }}{{ file.name.length > 40 ? '...' : '' }}
            </div>
            <div class="secondary-text">{{ file.size | fileSize }}</div>

            <mat-form-field
              color="accent"
              class="w-100-p pt-8 m-0 form-control"
            >
              <mat-label>Summary</mat-label>
              <input
                id="summary"
                matInput
                #input
                class="form-control"
                value="{{ this.fileSummaryList[file.name] }}"
                name="summary"
                (input)="summaryTextChanged($event.target.value, file.name)"
              />
            </mat-form-field>

            <mat-progress-bar
              *ngIf="progress"
              class="py-4"
              mode="determinate"
              [value]="progress[file.name].progress | async"
            ></mat-progress-bar>
            <div *ngIf="progress" class="errorInfo">
              {{ progress[file.name].progressErrors | async }}
            </div>
          </div>
          <div *ngIf="canAddFiles">
            <button
              mat-icon-button
              class="mat-icon-button"
              (click)="removeFile(file)"
              aria-label="Remove File"
              matTooltip="Remove file from the list of files to upload"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-actions
    style="
      padding: 16px 16px 16px 16px;
      margin-bottom: 0px;
      min-height: 64px;
      justify-content: center;
    "
  >
    <button
      [disabled]="
        canAddFiles == false || fileCount > this.defaultDataService.maxFileUploadLimit
      "
      mat-raised-button
      class="mat-accent"
      (click)="addFiles()"
    >
      ADD FILES
    </button>
    <button
      [disabled]="!canBeClosed"
      *ngIf="
        fileCount > 0 && !(fileCount > this.defaultDataService.maxFileUploadLimit)
      "
      style="margin: 0px 2px 0px 2px"
      mat-raised-button
      class="mat-accent"
      (click)="btnUploadOrClose()"
    >
      {{ primaryButtonText }}
    </button>
  </mat-dialog-actions>
  <div id="dropzone" class="dropzone">
    <div
      class="col-md-12 hint-text mat-h3 select-task-text"
      style="text-align: center"
    >
      or drag and drop files here
    </div>
  </div>
</div>
<!-- </div> -->
